import { useMemo, type ComponentProps } from "react";

import CrmEnrichmentJobReviewCredits from "app/pages/sales-intelligence/modules/crm-enrichment/components/wizard/CrmEnrichmentJobReviewCredits";
import CrmEnrichmentJobReviewWizardStep from "app/pages/sales-intelligence/modules/crm-enrichment/components/wizard/CrmEnrichmentJobReviewWizardStep";
import type { EnrichmentJobMappingDTO } from "app/pages/sales-intelligence/modules/crm-enrichment/types/types";
import { mappingsToPriceFields } from "app/pages/sales-intelligence/modules/crm-enrichment/utils/job";

import useHsEnrichmentJobPriceQuery from "../../queries/useHsEnrichmentJobPriceQuery";

type Props = ComponentProps<typeof CrmEnrichmentJobReviewWizardStep> & {
    mappings: readonly EnrichmentJobMappingDTO[];
};

const HsJobReviewWizardStepContainer = ({ mappings, ...props }: Props) => {
    const priceFields = useMemo(() => mappingsToPriceFields(mappings), [mappings]);

    const { data, isLoading } = useHsEnrichmentJobPriceQuery(priceFields);

    return (
        <CrmEnrichmentJobReviewWizardStep {...props}>
            <CrmEnrichmentJobReviewCredits
                priceData={data}
                isLoading={isLoading}
            />
        </CrmEnrichmentJobReviewWizardStep>
    );
};

export default HsJobReviewWizardStepContainer;
